import React from "react";
import { useTranslation } from "react-i18next";
import newOfficeImage1 from "../assets/new-office-image-1.jpg";
import "../App.scss";

const AnnouncementPopup = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="popup-backdrop" onClick={handleBackdropClick}>
      <div className="popup-container">
        <button className="popup-close-btn" onClick={onClose}>
          ×
        </button>

        <div className="popup-header">
          <div className="popup-brand-name">{t("brand-name")}</div>
        </div>

        <div className="popup-title">
          {t("popup-important-title")}
        </div>

        <div className="popup-content">
          <div className="popup-new-office-announcement">
            <p className="popup-main-announcement">✨ {t("popup-new-office-announcement")} ✨</p>
          </div>

          <div className="popup-office-image">
            <img src={newOfficeImage1} alt="New Sigma Office" className="popup-office-img" />
          </div>

          <p className="popup-welcome-text">
            {t("popup-welcome-message")}
          </p>

          <div className="popup-address-section">
            <p className="popup-address-text">
              📍 {t("popup-new-address")}
            </p>
          </div>

          <p className="popup-description-text">
            {t("popup-office-description")}
          </p>

          <div className="popup-services-list">
            <p className="popup-services-header">{t("popup-services-header")}</p>
            <div className="popup-services-items">
              <p>🔹 {t("popup-service-1")}</p>
              <p>🔹 {t("popup-service-2")}</p>
              <p>🔹 {t("popup-service-3")}</p>
              <p>🔹 {t("popup-service-4")}</p>
            </div>
          </div>

          <p className="popup-closing-message">
            👍 {t("popup-closing-message")}
          </p>
        </div>

        <div className="popup-signature">
          <div className="popup-divider">_______</div>
          <p className="popup-signature-text">
            {t("popup-signature")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementPopup;